module.exports = __webpack_public_path__ + "static/img/7-3.e710477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/7-3.png
// module id = 5ZwM
// module chunks = 1